/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Integration_Create_TitleInputs */

const cs_integration_create_title = /** @type {(inputs: Integration_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nová integrace`)
};

const en_integration_create_title = /** @type {(inputs: Integration_Create_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`New integration`)
};

/**
* | output |
* | --- |
* | "New integration" |
*
* @param {Integration_Create_TitleInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const integration_create_title = /** @type {((inputs?: Integration_Create_TitleInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Integration_Create_TitleInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_integration_create_title(inputs)
	return cs_integration_create_title(inputs)
});